function Image({ dimensions, col = '#000' }) {
  const baseXml = `
        <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6667 1.33333V10.6667H1.33333V1.33333H10.6667ZM10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM7.42667 5.90667L5.42667 8.48667L4 6.76L2 9.33333H10L7.42667 5.90667Z" fill="black"/>
        </svg>
    `;
  return baseXml;
}

export default Image;
